import { render, staticRenderFns } from "./HumanMap.vue?vue&type=template&id=18b34e9e&scoped=true&"
import script from "./HumanMap.vue?vue&type=script&lang=js&"
export * from "./HumanMap.vue?vue&type=script&lang=js&"
import style0 from "./HumanMap.vue?vue&type=style&index=0&id=18b34e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b34e9e",
  null
  
)

export default component.exports